// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"a2e05abf","297":"4b91df0f","643":"1daa3bfa"}[chunkId] + ".chunk.js";
};